import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import EmployerForm from '../EmployerForm';

export const EmployerFormStyled = styled(EmployerForm)`
  border-color: ${colors.blue[200]};
`;

export const FormWrapperStyled = styled.div`
  position: relative;
`;

export const CancelButtonStyled = styled(Button)`
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
  width: 3rem;
  height: 3rem;
`;
